import * as constants from '../constants';

export const requestAnalytics = (id, type, params, startDate, endDate, instanceType = constants.INSTANCE_FILTERS.COMPLETED) =>
    ({type: constants.ANALYTICS_REQUESTED, payload: {id, params, type, startDate, endDate, instanceType}});
export const requestAnalyticsBatch = (items, startDate, endDate, instanceType = constants.INSTANCE_FILTERS.COMPLETED) =>
    ({type: constants.ANALYTICS_BATCH_REQUESTED, payload: {items, startDate, endDate, instanceType}});
export const analyticsLoading = (id) => ({type: constants.ANALYTICS_LOADING, payload: {id}});
export const analyticsSuccess = (id, data) => ({type: constants.ANALYTICS_SUCCESS, payload: {id, data}});
export const analyticsFailure = (id, error) => ({type: constants.ANALYTICS_FAILURE, payload: {id, error}});
